import { useEffect, useRef } from 'react'

/**
 * 滚动锁定 Hook
 * 当 isLocked 为 true 时锁定页面滚动，false 时恢复原始状态
 * @param isLocked 是否锁定滚动
 */
export function useScrollLock(isLocked: boolean) {
  const initHTMLOverflowProp = useRef<string | undefined>(undefined)

  useEffect(() => {
    if (typeof initHTMLOverflowProp.current === 'undefined') {
      initHTMLOverflowProp.current = document.documentElement.style.overflow
    }
    document.documentElement.style.overflow = isLocked ? 'hidden' : initHTMLOverflowProp.current
  }, [isLocked])
}

export default useScrollLock
